import { IntegrationEntitySyncTag } from "components";
import { DefaultHeaderCell } from "components/table-v2/header-cells";
import { DefaultRowCell } from "components/table-v2/row-cells";
import { ITableV2Column } from "components/table-v2/table-v2";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { TOpenViewSyncLeadSourceExtendedData } from "types/openview.type";
import { OpenViewLeadSourceSyncSelect } from "./OpenViewLeadSourceSyncSelect";

export const syncOpenViewLeadSourceTableColumnDef = (
  accountStore: UserAccountStore,
  updateSyncPair: (syncPair: TOpenViewSyncLeadSourceExtendedData) => void
): ITableV2Column<TOpenViewSyncLeadSourceExtendedData>[] => {
  return [
    {
      accessor: "leadSourceName",
      Header: <DefaultHeaderCell>LeadPro source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell textTransform={"capitalize"}>
          {row.leadSourceName}
        </DefaultRowCell>
      ),
    },
    {
      accessor: "openViewSource",
      excludeFromGlobalFilter: true,
      disableSortBy: true,
      Header: <DefaultHeaderCell>iamproperty CRM source</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <OpenViewLeadSourceSyncSelect
            accountStore={accountStore}
            onChange={updateSyncPair}
            record={row}
          />
        </DefaultRowCell>
      ),
    },
    {
      accessor: "syncStatus",
      excludeFromGlobalFilter: true,
      Header: <DefaultHeaderCell>Status</DefaultHeaderCell>,
      Cell: ({ row }) => (
        <DefaultRowCell>
          <IntegrationEntitySyncTag syncStatus={row.syncStatus} />
        </DefaultRowCell>
      ),
    },
  ];
};
